export default "__VITE_ASSET__80681abd__"